export const moduleName = 'infrastructure';

export const types = {
  CLEAR_REDIRECT_DATA: `${moduleName}/CLEAR_REDIRECT_DATA`,
  SET_REDIRECT_DATA: `${moduleName}/SET_REDIRECT_DATA`,
};
